(function($){

    // Mobile menu
    $('.header-menu').on('click keypress', function(){
        $(this).toggleClass('open')
        $('.mobile_menu').toggleClass('active')
        if($(this).hasClass('open')){
            $('.accordion-menu a, .accordion-menu button').removeAttr('tabindex')    
        } else {
            $('.accordion-menu a, .accordion-menu button').attr('tabindex', "-1")
        }
        
    })

    $('.search-button').on('click keypress', function(){
        $('.search-bar').toggleClass('active')
        if($('.search-bar').hasClass('active')){
            $('.search-field, .search-submit').removeAttr('tabindex')    
        } else {
            $('.search-field, .search-submit').attr('tabindex', "-1")
        }
    })
    
    // Cookie functions
    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==" ") c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function eraseCookie(name) {   
        document.cookie = name+"=; Max-Age=-99999999;";  
    }

    $('.accordion-menu a, .accordion-menu button').attr('tabindex', "-1")

})(jQuery);